"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TooltipPosition: function() {
        return TooltipPosition;
    },
    Tooltip: function() {
        return Tooltip;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _icon = /*#__PURE__*/ _interopRequireWildcard(require("../Icon"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var TooltipPosition;
(function(TooltipPosition) {
    TooltipPosition["LEFT"] = "left";
    TooltipPosition["RIGHT"] = "right";
    TooltipPosition["TOP"] = "top";
    TooltipPosition["BOTTOM"] = "bottom";
})(TooltipPosition || (TooltipPosition = {}));
var Tooltip = function(param) {
    var className = param.className, _param_contentClassName = param.contentClassName, contentClassName = _param_contentClassName === void 0 ? "bg-gray-900" : _param_contentClassName, _param_triangleColor = param.triangleColor, triangleColor = _param_triangleColor === void 0 ? "text-gray-900" : _param_triangleColor, _param_position = param.position, position = _param_position === void 0 ? TooltipPosition.TOP : _param_position, children = param.children, content = param.content, _param_action = param.action, action = _param_action === void 0 ? "hover" : _param_action;
    var _useState = _slicedToArray((0, _react.useState)(false), 2), showTooltip = _useState[0], setShowTooltip = _useState[1];
    var classes = {
        container: (0, _classnames.default)(_defineProperty({
            "relative inline-block": true
        }, className || "", className)),
        body: (0, _classnames.default)({
            "cursor-pointer leading-none": true
        }),
        content: (0, _classnames.default)(_defineProperty({
            "absolute transition duration-150 ease-in-out shadow-lg w-max px-3 py-2 rounded-md z-20 transform animate-fade-in": true,
            "left-1/2 bottom-full -translate-x-1/2 -translate-y-3": position === TooltipPosition.TOP,
            "left-1/2 top-full -translate-x-1/2 translate-y-3": position === TooltipPosition.BOTTOM,
            "top-1/2 right-full -translate-y-1/2 -translate-x-3": position === TooltipPosition.LEFT,
            "top-1/2 left-full -translate-y-1/2 translate-x-3": position === TooltipPosition.RIGHT
        }, contentClassName, contentClassName)),
        triangle: (0, _classnames.default)(_defineProperty({
            "absolute transform": true,
            "bottom-0 left-1/2 -translate-x-1/2 translate-y-full": position === TooltipPosition.TOP,
            "top-0 left-1/2 -translate-x-1/2 rotate-180 -translate-y-full": position === TooltipPosition.BOTTOM,
            "right-0 top-1/2 -translate-y-1/2 -rotate-90 translate-x-2": position === TooltipPosition.LEFT,
            "left-0 top-1/2 -translate-y-1/2 rotate-90 -translate-x-2": position === TooltipPosition.RIGHT
        }, triangleColor, true))
    };
    return /*#__PURE__*/ _react.default.createElement("span", {
        className: classes.container,
        onMouseEnter: function() {
            return action === "hover" && setShowTooltip(true);
        },
        onMouseLeave: function() {
            return action === "hover" && setShowTooltip(false);
        },
        onClick: function() {
            return action === "click" && setShowTooltip(!showTooltip);
        }
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: classes.body
    }, children), showTooltip && /*#__PURE__*/ _react.default.createElement("span", {
        className: classes.content,
        role: "tooltip"
    }, /*#__PURE__*/ _react.default.createElement(_icon.Triangle, {
        className: classes.triangle
    }), content));
};

//# sourceMappingURL=Tooltip.js.map